// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"e8f1e39e","297":"a5c8f8d3","643":"775e3469","787":"c4478a05"}[chunkId] + ".chunk.js";
};